<template>
  <AcademicCardsChapter
    page-title="学术沙龙活动"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :sections="sections"
  />
</template>

<script>
import AcademicCardsChapter from '@/components/AcademicCardsChapter.vue';

export default {
  name: 'Lanhuxueshushalong',
  components: {
    AcademicCardsChapter
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      sections: [
        {
          title: '学术沙龙活动',
          summary: '从午餐沙龙到“品道”系列活动，研究所持续通过轻量而高密度的交流机制推动学术讨论。',
          columns: 2,
          cards: [
            {
              title: '2015 年第 50 次“品道”学术沙龙',
              src: require('./assets/html/salon-2015.jpg'),
              description: '2015 年 3 月，第 50 次“品道”学术沙龙举行，芬兰韦斯屈莱大学 Stephen M. Croucher 参与交流。'
            },
            {
              title: '2009 年第一次午餐学术沙龙',
              src: require('./assets/html/salon-2009.jpg'),
              description: '2009 年 7 月，第一次午餐学术沙龙举行，所领导为沙龙开锣。'
            },
            {
              title: '2017 年第 59 次“品道”学术沙龙',
              src: require('./assets/html/salon-2017.jpg'),
              description: '2017 年 11 月，第 59 次“品道”学术沙龙举行，Kathy Hibbert 博士参与活动。'
            }
          ]
        }
      ]
    };
  }
};
</script>
